@for (region of vm.regions; track indx; let indx = $index) {
    <div class="day-of-race-lobby__regions">
        @if (isGreyhoundsStyle) {
            <div class="greyhounds-region-name-container">
                <div class="region-name" msTextAutoScroll [class.has-description]="indx === 0">{{ region.name }}</div>
                @if (indx === 0) {
                    <div class="greyhounds-description">
                        <span class="color-priced"></span> <span class="priced">{{ sitecore.horseRacing.tournaments.Priced }}</span>
                        @if (showLegend) {
                            <span class="color-ongoing"></span> <span class="ongoing">{{ sitecore.horseRacing.tournaments.Ongoing }}</span>
                            <vn-icon name="sports-race-resulted" height="12" width="8" class="icon-sports-race-resulted" />
                            <span class="resulted">{{ sitecore.horseRacing.tournaments.Resulted }}</span>
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="region-name-container">
                @if (indx === 0) {
                    <div class="description">
                        <span class="color-priced"></span> <span class="priced">{{ sitecore.horseRacing.tournaments.Priced }}</span>
                        @if (showLegend) {
                            <span class="color-ongoing"></span> <span class="ongoing">{{ sitecore.horseRacing.tournaments.Ongoing }}</span>
                            <vn-icon name="sports-race-resulted" height="12" width="8" class="icon-sports-race-resulted" />
                            <span class="resulted">{{ sitecore.horseRacing.tournaments.Resulted }}</span>
                        }
                    </div>
                }
                <div class="region-name" msTextAutoScroll [class.has-description]="indx === 0">{{ region.name }}</div>
            </div>
        }

        @for (meeting of region.meetings; track $index) {
            <div class="day-of-race-lobby__region" [ngClass]="{ 'greyhounds-day-of-race-lobby': isGreyhoundsStyle }">
                <div class="tournament">
                    <a [href]="meeting.link">
                        <div>
                            <div
                                [ngClass]="
                                    isGreyhoundsStyle ? 'tournament-name-greyhounds ms-active-highlight' : 'tournament-name ms-active-highlight'
                                ">
                                {{ meeting.meetingName }}
                                @if (promotedMeetingIdsMap[meeting.fixtures[0].meeting.id]) {
                                    <ms-promotion-badge />
                                }
                            </div>
                            @if (!isGreyhoundsStyle) {
                                <ms-best-odds-counter [fixtures]="meeting.fixtures" />
                            }
                        </div>
                    </a>
                    <ms-day-of-race-meeting-list
                        [fixtures]="meeting.fixtures"
                        [crmPromotedFixtureIdsMap]="promotedFixtureIdsMap"
                        [ngClass]="isGreyhoundsStyle ? 'day-of-race-meeting-list-greyhounds' : 'day-of-race-meeting-list'" />
                </div>
            </div>
        }
    </div>
}
